<template>
  <div class="">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formSearch" class="demo-form-inline">
        <!-- <el-form-item label="名称">
          <el-input v-model="formSearch.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item> -->
        
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formSearch.type == item.key_name ? 'primary' : ''" plain v-for="(item, index) in type" :key="index" @click="changeTypeFunc(item.key_name)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>
        <br>

        <el-form-item label="用户id">
          <el-input v-model="formSearch.user_id" placeholder="请输入" clearable style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formSearch.status" clearable placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="结束" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="添加日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formSearch.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>

        <el-form-item label="完成日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formSearch.complete_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- <div>
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加</el-button>
    </div> -->

    <!--内容-->
    <div class="content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="shuati_id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="user" label="微信头像" width="70">
            <template slot-scope="scope" v-if="scope.row.user">
              <img :src="scope.row.user.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
              <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          
          <el-table-column prop="type" label="类型" width="100">
            <template slot-scope="scope">
              <p v-if="type[scope.row.type]">{{ type[scope.row.type].name }}</p>
              <p v-if="scope.row.year">{{ scope.row.year }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="category_str" label="分类"></el-table-column>
          <!-- <el-table-column prop="question" label="关联答题" width="100">
            <template slot-scope="scope">
              <el-button size="mini" href="/" target="_blank" @click="onDetail(scope.row)" v-if="scope.row.question_ids.length>0">查看</el-button>
            </template>
          </el-table-column> -->
          <el-table-column prop="question_ids.length" label="答题数量" width="80" align="center"></el-table-column>
          <el-table-column prop="accuracy" label="正确率(%)" width="80" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="score" label="分数" width="80" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="use_time" label="用时" width="80" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="full_score" label="满分" width="80" align="center"></el-table-column>
          <el-table-column prop="pass_score" label="及格分数" width="80" align="center"></el-table-column>
          <el-table-column prop="valid_minute" label="时限（分钟）" width="80" align="center"></el-table-column>
          <!-- <el-table-column prop="remark" label="备注" width="150"></el-table-column> -->
          <el-table-column prop="status" label="状态" width="60" align="center">
            <template slot-scope="scope">
              <span class="" v-if="scope.row.status == 2">结束</span>
              <span class="green" v-else-if="scope.row.status == 1">进行中</span>
              <span class="gray9" v-else>无效</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="complete_time" label="完成时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="name" label="操作" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openPopup('detail', scope.row)" type="text" size="small">查看详情</el-button>
              <el-button type="text" size="mini" href="/" target="_blank" @click="onDetail(scope.row)" v-if="scope.row.question_ids.length>0">关联答题</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <!-- <Add v-if="open_add" :open_add="open_add" :type="type" @closeDialog="closeDialogFunc($event, 'add')"></Add> -->

    <!--编辑-->
    <!-- <Edit v-if="open_edit" :open_edit="open_edit" :type="type" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit> -->

    <!--题库选择-->
    <!-- <Question v-if="open_quest" :open_quest="open_quest" :selectModel="selectModel" @callBackFun="callBackFun" @closeDialog="closeDialogFunc($event, 'quest')"></Question> -->

    <!--批量-->
    <Detail v-if="show_popup['detail']" :is_open="show_popup['detail']" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'detail')"></Detail>
  </div>
</template>
<script>
  import ShuatiApi from '@/api/study/shuati.js';
  // import Edit from './part/Edit.vue';
  // import Add from './part/Add';
  import Detail from './part/Detail';
  // import Question from '@/components/study/Question.vue';
  import qs from 'qs';
  export default {
    components: {
      // Add,
      // Edit,
      // Question,
      Detail
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formSearch: {
          user_id: '',
          name: '',
          type: '',
          status: '',
          create_time: '',
        },
        /*弹窗*/
        show_popup: {
          detail: false,
        },
        /*选中的对象*/
        selectModel:{},
        type:[],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formSearch, params);

      // 默认
      let type = this.$db.getRouteField(this, 'type');
      if (type) this.formSearch.type = type;

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*跳转详情*/
      onDetail(row) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let params = {shuati_id: row.shuati_id};
        baseUrl = this.$filter.isDebug() ? '' : '/shop';
        window.open(baseUrl + '/#/study/questionlibrary/index?' + qs.stringify(params));
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formSearch;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        ShuatiApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.type = data.type;
          self.totalDataNumber = data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            ShuatiApi.del({section_id: row.section_id},true)
              .then(data => {
                if (data.code == 1) {
                  self.loading = false;
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.getTableList();
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {});
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formSearch;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.show_popup[name] = true;
        if (item) this.selectModel = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },

      /*保存题库*/
      callBackFun(e){
        let self = this;
        StudyGroupApi.edit({group_id:self.selectModel.group_id, question_ids:e.ids}, true)
        .then(res => {
          if (res.code == 1) {
            self.$message({
              message: res.msg,
              type: 'success',
            });
            self.getTableList();
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
      },
      /*选择类型*/
      changeTypeFunc(e){
        this.formSearch.type = e;
        this.$db.setRoute(this, {'type': e});
        this.getTableList();
      },

      /*导出*/
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/study.shuati/export?' + qs.stringify(this.formSearch);
      },

    }
  };
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/study/shuati/index.vue